import styled from "styled-components";

const ImageLargePreview = styled.img`
  width: 432px;
  height: 400px;
`;

export default ImageLargePreview;
